import DateTimeHelper from '@/components/mixins/DateTimeHelper'

export default {
  mixins: [DateTimeHelper],
  methods: {
    getOrgaDuration (orgaDetails) {
      if (orgaDetails.begin && orgaDetails.end) {
        return `(${this.asDate(orgaDetails.begin)} - ${this.asDate(orgaDetails.end)})`
      } else if (orgaDetails.begin) {
        return `(${this.$gettext('Organisationseinheit.list.column.beginn').toLowerCase()} ${this.asDate(orgaDetails.begin)})`
      } else if (orgaDetails.end) {
        return `(${this.$gettext('Organisationseinheit.list.column.ende').toLowerCase()} ${this.asDate(orgaDetails.end)})`
      } else {
        return ''
      }
    }
  },
  computed: {
    currentLocale () {
      return this.$language.current.substring(0, 2).toLowerCase()
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/OrgaDurationHelper.js